export default __webpack_public_path__ + "static/media/branding-stat-2.17c06bc9.jpg";